<template lang="pug">
  #intro
    #landing    
      .logoHeader
        a(href="http://mvdf.datacivica.org/" target="_blank")
          img#mvdf(src="/assets/logos/mvdf-logo.svg")
        img#ceav(src="/assets/logos/CEAV_logo_blanco.svg")
      h1.welcome.boldest Narrativa de
        br
        .green El Quemado
      i.fa.fa-arrow-circle-down(style={fontSize:"33px"})
    #description              
      img.prisioneros(
        src="/assets/Mobile/Intro-Section1/double.jpg"
        )
      img.prisioneros(
        src="/assets/Mobile/Intro-Section1/double.jpg"
        )
      #par1.centered(
        data-sal="fade"
        data-sal-delay="50"
        data-sal-easing="ease"
        )
        p.italic.small.left
          |  “El arresto, la detención, el secuestro o cualquier otra forma de privación de libertad que sean obra de agentes del Estado,
          |  o de personas o grupos de personas que actúan con la autorización, el apoyo o la aquiescencia del Estado,
          |  seguida de la negativa a reconocer dicha privación de libertad o del ocultamiento de la suerte o el paradero de la
          |  persona desaparecida, sustrayéndola a la protección de la ley.”
          br
          br
        p.green.bold.small.left
          |  – Art. 2 de la Convención contra la Desaparición Forzada
          br
          |  de la ONU, que México firmó en 2001
      #par2.centered(
        data-sal="fade"
        data-sal-delay="50"
        data-sal-easing="ease"
        )
        p.bold.small
          |  La desaparición forzada es una forma de violencia
          |  que en México tiene más de medio siglo de práctica.
      #par3.centered(
        data-sal="fade"
        data-sal-delay="50"
        data-sal-easing="ease"
        )
        p.bold.small
          |  Esta es la historia de
          span.green  106 hombres
          |  que entre
          |  el 2 a 5 de septiembre de 1972 fueron
          span.green  secuestrados por el Ejército Mexicano
          |  en un pueblo llamado El Quemado.
</template>
<script>
import sal from 'sal.js'
import simpleParallax from 'simple-parallax-js'

export default {
  name: "Intro",
  methods: {
    initialize() {
      // animations
      sal({
        threshold: 1,
        once: false,
      });

      // parallax
      var image = document.getElementsByClassName('prisioneros');
      new simpleParallax(image, {
        delay: .8,
        transition: 'cubic-bezier(0,0,0,1)',
        overflow: false,
      });
    }
  },
  mounted() {
    this.initialize();
  }
}
</script>
<style lang="scss" scoped>


#landing{
  height: 100vh;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background-image: linear-gradient(rgba(0, 0, 0, 0.68),rgba(0, 0, 0, 0.68)),
    url("/assets/Mobile/Intro-Section1/_MG_7351 Mobile.jpg");
  h1{
    font-size: 2.2rem;
  }
  .logoHeader{
    width: 100%;
    height: 15vh;
    max-height: 16vh;
    display: flex;
    justify-content: space-between;
    padding: 0 5vw 0 5vw;
    a #mvdf{
      height: auto;
      width: 20vw;
      z-index: 2;
    }
    #ceav{
      height: 3rem;
      width: 30vw;
      z-index: 2;
    }
  }
}


#description{
  background-color: #1E1E1E;
  position: relative;
  max-height: 300vh;
  padding-top:0;
  .prisioneros{
    width: 82%;
    opacity: 0.27;
    //height: fit-content;
    object-fit: contain;
  }
  p {
    width: 80vw; 
  }
  .left {
      text-align: left;
    }
  .centered{
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  #par1{
    top: 25%;
    padding-top: 5vh;
    padding-bottom: 5vh;
  }

  #par2{
    top: 50%;
    padding-top: 35vh;
    padding-bottom: 25vh;
  }

  #par3{
    top: 75%;
    padding-top: 25vh;
    padding-bottom: 25vh;
  }
}


</style>